const linkResolver = require('./link-resolver').linkResolver

export const repositoryConfigs = [
  {
    repositoryName: "driver-capital",
    linkResolver
  }
]
